module.exports = __webpack_public_path__ + "532db0aeeaf8ec8a68db922c79dc79c0.svg";